export default "__VITE_ASSET__94c2db6e__"